function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.392,19.825a8.29,8.29,0,0,1-5.217-5.217.665.665,0,0,0-1.261.42,9.623,9.623,0,0,0,6.057,6.059.675.675,0,0,0,.211.034.665.665,0,0,0,.21-1.3Z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.333,
  cy: 1.333,
  r: 1.333,
  transform: "translate(10.666 10.667)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12,7.111A4.889,4.889,0,1,0,16.889,12,4.889,4.889,0,0,0,12,7.111Zm0,8.448A3.559,3.559,0,1,1,15.559,12,3.564,3.564,0,0,1,12,15.559Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M21.086,8.972a9.623,9.623,0,0,0-6.057-6.059.665.665,0,0,0-.421,1.262,8.29,8.29,0,0,1,5.217,5.217.664.664,0,0,0,.631.455.673.673,0,0,0,.21-.034A.665.665,0,0,0,21.086,8.972Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22.67A10.67,10.67,0,1,1,22.67,12,10.683,10.683,0,0,1,12,22.67Z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/other_collectibles.c490d2c6.svg";
export { SvgComponent as ReactComponent };